module.exports = __webpack_public_path__ + "img/urban-logo-light.929cb9dc.png";